import React from 'react';
import {
  Filter,
  TextInput,
  SelectInput,
  NumberInput,
  BooleanInput,
  DateInput,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

const UserFilters = props => (
  <Filter {...props}>
    <TextInput label="ID" source="id" />
    <TextInput label="Email" source="email" />
    <SelectInput
      label="Role"
      source="role"
      choices={[
        { id: 'coach', name: 'Single Coach' },
        { id: 'company_coach', name: 'Company Coach' },
        { id: 'player', name: 'Player' },
        { id: 'company', name: 'Company' },
      ]}
    />
    <ReferenceInput label="Company" source="company_id" reference="companies">
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <BooleanInput label="Is Active" source="is_active" />
    <BooleanInput label="Commercial Agree" source="commercial_agree" />
    <BooleanInput label="VCorsi" source="vcorsi" />
    <TextInput label="Full Name" source="full_name" />
    <TextInput label="Phone Number" source="phone_number" />
    <TextInput label="Addresses" source="users-billing_address_id" />
    <DateInput label="Created At" source="users-created_at" />
    <DateInput label="Last Login At" source="users-last_login_at" />
    <DateInput label="Subscription End At" source="user_subscriptions-end_at" />
    <DateInput sx="{{color: 'aliceblue'}}" label="Subscription End At (Month)" source="user_subscriptions-end_at_month" /> 
    <NumberInput sx="{{color: 'aliceblue'}}" label="Offset Months" source="user_subscriptions-end_at_offset" />
    <BooleanInput sx="{{color: 'aliceblue'}}" label="New user flag" source="user_subscriptions-new_user" />
    <TextInput label="Export limit" source="export_limit" />
    <TextInput label="Export offset" source="export_offset" />
  </Filter>
);

export default UserFilters;



// WEBPACK FOOTER //
// ./src/resources/users/UserFilters.jsx